/* eslint-disable no-dupe-keys */
export default {
  billing_rule_temperature_timer: {
    name: '高温费率定时器',
    // 属性（一般与对象内容匹配）
    prop: {
      billing_rule: '高温费率',
      service_provider: '运营商',
      city: '参考的城市气温',
      charge_station: '充电站',
      effective_date: '费率生效日期',
      effective_begin_time: '生效开始日期',
      effective_end_time: '生效结束日期',
      status: '状态',
      temperature_greater_than: '生效的温度',
      last_executed_at: '最后执行时间',
      next_3day_notice: '近3天预告',
      description: '描述',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      pending: '待生效',
      active: '生效中',
      invalid: '已失效'
    },
    real_statuses: {
      enabled: '可用',
      disabled: '禁用'
    },
    temperature_records_is_active: {
      true: '生效',
      false: '不生效'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      input_description: '请输入描述'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      execution_record: '执行记录'
    },
    // 标签标题
    list_tabs: {
      all: '全部'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      current_billing_rule: '站当前费率',
      high_tem_billing_rule: '高温费率'
    },
    group_titles: {
      base: '基础信息',
      condition: '生效条件'
    },
    // 提示
    tips: {
      effective_time_consuming: '将会在 {0} ~ {1} 的20点30分检测明后几天的温度',
      daily_worker: '每天20:30自动检测，未来3天内如果满足高温设定，则高温费率会绑定到对应充电站的特定日费率上',
      delete_dialog: '删除定时器会同时清除充电站当前的高温费率，'
    }
  }
}
